/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { GH, GW } from '../lib/config.js';
import { PALETTE_HEX } from '../lib/palette.js';

export default {
  onCanvasContext(e) { e.preventDefault(); },

  onMouseDown(e) {
      if (this.state.playing) { this.stopPlay(); return; }
      // Rechtermuisknop wist, zonder van tool te wisselen. Niet bij pen, vormen
      // en selecteren: daar klikt de rechterknop nergens op.
      this.rightErase = false;
      if (e.button === 2) {
        if (this.state.tool === 'pen' || this.isShapeTool(this.state.tool) || this.isSelectTool(this.state.tool)) return;
        const p = this.getPos(e);
        this.rightErase = true;
        this.pushUndo();
        this.setHover(p.x, p.y);
        this.setState({ drawing: true });
        this.lastPaint = null;
        this.strokeTo(p.x, p.y, null);
        this.duoTick();
        return;
      }
      if (this.isSelectTool(this.state.tool)) { this.onSelDown(e); return; }
      const { x, y } = this.getPos(e);
      const color = PALETTE_HEX[this.state.primaryIndex];
      if (this.state.tool === 'pen') {
        if (!this.penPts) {
          this.pushUndo();
          this.penBase = this.getCtx().getImageData(0, 0, GW, GH);
          this.penPts = [{ x, y, hx: 0, hy: 0 }];
          this.penDrag = 0;
          this.penDragOn();
          this.setHover(x, y);
          this.setState({ drawing: true });
          this.renderPen(null);
          return;
        }
        const first = this.penPts[0], last = this.penPts[this.penPts.length - 1];
        if (x === last.x && y === last.y) { this.finishPen(); return; }
        if (this.penPts.length > 2 && x === first.x && y === first.y) { this.penClosed = true; this.finishPen(); return; }
        this.penPts.push({ x, y, hx: 0, hy: 0 });
        this.penDrag = this.penPts.length - 1;
        this.penDragOn();
        this.setHover(x, y);
        this.renderPen(null);
        return;
      }
      if (this.isShapeTool(this.state.tool)) {
        this.pushUndo();
        this.lineBase = this.getCtx().getImageData(0, 0, GW, GH);
        this.lineFrom = { x, y };
        this.lastCur = { x, y };
        this.setHover(x, y);
        this.setState({ drawing: true });
        this.drawShape(x, y, x, y, color);
        this.duoTick();
        return;
      }
      if (this.state.tool === 'fill') { this.pushUndo(); this.floodFill(x, y, color); this.snapshotCanvas(); return; }
      this.pushUndo();
      this.setHover(x, y);
      this.setState({ drawing: true });
      this.lastPaint = null;
      this.strokeTo(x, y, color);
      this.duoTick();
    },

  onMouseMove(e) {
      if (this.isSelectTool(this.state.tool)) return;
      const { x, y } = this.getPos(e);
      // Geen setState hier. Zie setHover: het aanwijskadertje wordt rechtstreeks
      // getekend, want anders kost elke muisbeweging een volledige hertekening.
      this.setHover(x, y);
      if (this.state.tool === 'pen') {
        if (!this.penPts) return;
        // Slepen vanaf een net gezet punt buigt de lijn, net als in Illustrator.
        if (this.penDrag != null) {
          const a = this.penPts[this.penDrag];
          a.hx = x - a.x; a.hy = y - a.y;
          this.renderPen(null);
          return;
        }
        this.renderPen({ x, y, hx: 0, hy: 0 });
        return;
      }
      if (this.isShapeTool(this.state.tool)) {
        if (!this.state.drawing || !this.lineFrom || !this.lineBase) return;
        // Met spatie ingedrukt verschuift de hele vorm mee met de muis in plaats
        // van groter of kleiner te worden.
        const cur = this.lastCur || { x, y };
        if (this.spaceHeld) {
          // Het eindpunt volgt de muis al; alleen het beginpunt hoeft mee te
          // schuiven, dan verhuist de vorm zonder van maat te veranderen.
          this.lineFrom = { x: this.lineFrom.x + (x - cur.x), y: this.lineFrom.y + (y - cur.y) };
        }
        this.lastCur = { x, y };
        this.shiftHeld = !!e.shiftKey;
        this.redrawShape(x, y);
        this.duoTick();
        return;
      }
      if (!this.state.drawing) return;
      this.strokeTo(x, y, PALETTE_HEX[this.state.primaryIndex]);
      this.duoTick();
    },

  onMouseUp() { this.spaceHeld = false; this.shiftHeld = false; if (this.rightErase) { this.rightErase = false; this.lastPaint = null; this.snapshotCanvas(); this.setState({ drawing: false }); return; } if (this.state.tool === 'pen') { this.penDrag = null; return; } this.lastPaint = null; this.lineFrom = null; this.lineBase = null; this.lastCur = null; this.snapshotCanvas(); if (this.state.drawing) this.setState({ drawing: false }); },

  onCanvasLeave() {
      this.rightErase = false;
      if (this.isSelectTool(this.state.tool)) return;
      if (this.state.tool === 'pen') { if (this.penPts) this.renderPen(null); this.setHover(null); return; }
      this.spaceHeld = false; this.shiftHeld = false;
      this.lastPaint = null; this.lineFrom = null; this.lineBase = null; this.snapshotCanvas(); this.setHover(null); this.setState({ drawing: false });
    },

  /**
   * Het paarse kadertje onder de cursor, dat laat zien waar en hoe groot je gaat
   * tekenen.
   *
   * Dit ging vroeger door `setState`, en dus door `renderVals` en de hele boom:
   * 13 ms rekenen en zo'n 30 ms tot beeld, bij elke cel die je cursor raakte. Het
   * kadertje is één div, dus die schrijven we nu direct. Het lijntje dat je tekent
   * ging altijd al rechtstreeks naar het canvas; dit is dezelfde aanpak.
   *
   * `x` op null zet het kadertje uit.
   */
  setHover(x, y) {
      const cel = x === null ? null : { x, y };
      const oud = this.hoverCell;
      if (!cel && !oud) return;
      if (cel && oud && oud.x === cel.x && oud.y === cel.y) return;
      this.hoverCell = cel;
      this.paintHover();
    },

  /**
   * Zet de plek en de maat van het kadertje op de div zelf. Wordt ook door
   * componentDidUpdate aangeroepen, want de maat hangt af van de penseelbreedte
   * en van welk gereedschap actief is.
   */
  paintHover() {
      const el = this.hoverRef.current;
      if (!el) return;
      const hc = this.hoverCell;
      if (!hc || this.isSelectTool(this.state.tool)) {
        el.style.display = 'none';
        return;
      }
      const b = this.state.brushSize;
      const off = Math.floor((b - 1) / 2);
      el.style.display = 'block';
      el.style.left = ((hc.x - off) / GW) * 100 + '%';
      el.style.top = ((hc.y - off) / GH) * 100 + '%';
      el.style.width = (b / GW) * 100 + '%';
      el.style.height = (b / GH) * 100 + '%';
    },

  duoTick() { if (this.state.duo) this.duoQueueSend(); }
};
